import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import Table from "../components/Table";
import ModalImage from "../components/ModalImage";
import bg from "../assets/images/bg-headers.png";
import {
  dataURItoBlob,
  ExportAuthTableExcelQueue,
  generateArrayPages,
  toastNotify,
} from "../utils/Utils";
import { ReactComponent as ExportIcon } from "../assets/icons/download.svg";
import { ReactComponent as ArrowIcon } from "../assets/icons/arrow.svg";
import _ from "lodash";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../components/auth/authContext";
import { requestAuthGet, requestAuthPost } from "../api/authInstance";
import { useTranslation } from "react-i18next";
import Datepicker from "../components/Datepicker";
import Header from "../components/Header";
import Button from "../components/Button/Button";
import ModalDcmForm from "../components/Modal/ModalDcmForm";
import withAuth from "../components/withAuth";
import ModalDcmUpload from "../components/Modal/ModalDcmUpload";
import ModalConfirmation from "../components/Modal/ModalConfirmation";
import ModalLoading from "../components/ModalLoading";
import { useLocation, useNavigate } from "react-router-dom";
import ModalBottom from "../components/Modal/ModalBottom";
import { compressImage, uploadFileToAsset } from "../utils/fileProcessing";

function CashManagement() {
  const { userData } = useAuth();
  const { t } = useTranslation();
  const { state } = useLocation();

  const [date, setDate] = useState({
    startDateLabel: new Date().setDate(new Date().getDate() - 7),
    endDateLabel: new Date(),
    startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [selected, setSelected] = useState("transaction");
  const [pageSelected, setPageSelected] = useState(1);
  const [showModalForm, setShowModalForm] = useState(false);
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [showModalOption, setShowModalOption] = useState(false);
  const [dataCount, setDataCount] = useState(0);
  const [formData, setFormData] = useState({});
  const [modalData, setModalData] = useState({});
  const [filter, setFilter] = useState({
    // transactionType: ["REDEMPTION", "TRANSIT"],
  });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [uploadedImages, setUploadImages] = useState([]);

  // * STATE IMAGE MODAL
  const [image, setImage] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingBalance, setLoadingBalance] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [balanceData, setBalanceData] = useState({});
  const [actualizationData, setActualizationData] = useState([]);

  // RedeemTransactions
  const [redeemTransactions, setRedeemTransactions] = useState({});
  const [outlets, setOutlets] = useState([]);
  const [loadingRedeemTransactions, setLoadingRedeemTransactions] =
    useState(true);
  const [uploadData, setUploadData] = useState({});

  useEffect(() => {
    if (userData) {
      GetSubmissionData({ isRefresh: true });
      setPageSelected(1);
    }
  }, [filter, date, userData]);

  useEffect(() => {
    if (userData) {
      GetSubmissionData({ isRefresh: false });
    }
  }, [pageSelected, userData]);

  useEffect(() => {
    if (state && state.mode === "create") {
      setShowModalForm(true);
    }
  }, [state]);

  useEffect(() => {
    if (formData.project) {
      GetBalance();
    }
  }, [formData.project]);

  const handleModalOption = (data) => {
    setModalData(data);
    setShowModalOption(true);
  };

  const GetSubmissionData = async ({ isRefresh, isDownload }) => {
    try {
      const cleanedParams = _.pickBy(filter, (value) => value !== "");
      setLoadingRedeemTransactions(true);
      const { startDateLabel, endDateLabel, ...filterDate } = date;
      const { data } = await requestAuthGet("ewallet-submission", {
        params: {
          ...cleanedParams,
          ...filterDate,
          // outlet: userData?.outlet?.id ?? null,
          retailer: userData?.outlet?.retailer?.id,
          page: isRefresh ? 1 : pageSelected,
          limit: isDownload ? 999999 : 10,
        },
      });
      if (isDownload) {
        return data.data;
      } else {
        setRedeemTransactions({ ...data });
        setDataCount(data.count);
      }
    } catch (error) {
      console.error("Error ewallet transactions data:", error);
    } finally {
      setLoadingRedeemTransactions(false);
    }
  };

  const GetBalance = async () => {
    try {
      setLoadingBalance(true);
      const { data } = await requestAuthGet("ewallet/balance", {
        params: {
          project: formData.project,
          retailer: userData?.outlet?.retailer?.id,
        },
      });
      setBalanceData({ ...data.data });
    } catch (error) {
      console.error("Error fetching balance data:", error);
    } finally {
      setLoadingBalance(false);
    }
  };

  const AddSubmission = async () => {
    setIsLoading(true);
    const { projectName, ...payload } = formData;
    requestAuthPost("ewallet-submission", {
      ...payload,
      userOutlet: userData.userOutlet,
      nominal: payload.nominal ? parseInt(payload.nominal) : 0,
    }).then((res) => {
      if (res.error) {
        setIsLoading(false);
        setShowModalForm(true);
        return toastNotify(
          res.detailMessage ?? "Failed to add submission",
          "error",
        );
      }
      GetSubmissionData({ isRefresh: true });
      setIsLoading(false);
      setFormData({});
    });
  };

  const AddHistory = async () => {
    setIsLoading(true);
    try {
      // Ensure there are images to upload
      // if (!uploadedImages || uploadedImages.length === 0) {
      //   toastNotify("Please upload at least one image.", "error");
      //   setIsLoading(false);
      //   return;
      // }

      const newImages = uploadedImages.filter(
        (file) => !file.url.startsWith("https://cdn.kar-tini.id/"),
      );

      // Upload images to the asset server
      const images = await Promise.all(
        newImages.map(async (fileObj) => {
          try {
            const { url, type, name } = fileObj;
            // Convert Base64 or object URL to Blob
            const blob = url.startsWith("data:")
              ? dataURItoBlob(url) // Convert Base64 to Blob
              : await fetch(url).then((res) => res.blob()); // Fetch Blob from object URL

            const fileName =
              name || (type === "application/pdf" ? "file.pdf" : "image.jpg");
            const fileType = type || "application/octet-stream";

            // Create a File object from the Blob
            let file = new File([blob], fileName, { type: fileType });

            // compress image
            file = await compressImage(file, 1);

            const uploadedUrl = await uploadFileToAsset(file);

            return { url: uploadedUrl, type }; // Extract the uploaded image URL
          } catch (error) {
            console.error("Error uploading image:", error);
            return null; // Return null for failed uploads
          }
        }),
      );

      // Filter out any failed uploads (null values)
      const validImages = images.filter((img) => img.url !== null);

      // Map uploaded images to the required format
      const documents = validImages.map(({ url, type }) => ({
        key: type === "application/pdf" ? "DOCUMENT" : "IMAGE",
        value: url,
      }));

      // Prepare the payload
      const { balance, typeModal, ...data } = uploadData; // Exclude balance if not needed
      const payload = {
        ...data,
        ...(uploadData.amount && !isNaN(parseInt(uploadData.amount, 10))
          ? { amount: parseInt(uploadData.amount, 10) }
          : {}),
        documents,
        userOutlet: userData.userOutlet,
      };

      // Send the payload to the server
      const response = await requestAuthPost("/cash-actualization", payload); // Adjust endpoint if needed

      if (response.error) {
        setIsLoading(false);
        setShowModalUpload(true);
        return toastNotify(
          response.detailMessage ?? "Failed to add history",
          "error",
        );
      }

      // Handle success

      toastNotify("History added successfully!", "success");
      GetSubmissionData({ isRefresh: true });
      // Reset state after successful submission
      setUploadData({});
      setUploadImages([]);
      setShowModalUpload(false);
      setIsLoading(false);
    } catch (error) {
      console.error("Error adding history:", error);
      toastNotify("Failed to add history. Please try again.", "error");
      setIsLoading(false);
    }
  };

  const options = {
    status: [
      {
        label: "All",
        value: "",
      },
      {
        label: "Menunggu Persetujuan",
        value: "WAITING_APPROVAL",
      },
      {
        label: "Disetujui",
        value: "APPROVED",
      },
      {
        label: "Perlu Penyelesaian",
        value: "PENDING_SETTLEMENT",
      },
      {
        label: "Ditolak",
        value: "REJECTED",
      },
      {
        label: "Selesai",
        value: "CLOSED",
      },
      {
        label: "Refund",
        value: "REFUND",
      },
    ],
  };

  const ProposalStatus = (status) => {
    switch (status) {
      case "WAITING_APPROVAL":
        return "Menunggu Persetujuan";
      case "APPROVED":
        return "Disetujui";
      case "PENDING_SETTLEMENT":
        return "Perlu Penyelesaian";
      case "REJECTED":
        return "Ditolak";
      case "CLOSED":
        return "Selesai";
      case "REFUND":
        return "Refund";
      default:
        return status;
    }
  };

  const columns = {
    transaction: useMemo(() => {
      const dynamicColumn = [
        {
          Header: "No.",
          Cell: ({ row }) => {
            return <div className="text-center">{row.index + 1}</div>;
          },
        },
        {
          Header: "Tanggal",
          accessor: "createdAt",
          headerClassName: "text-start",
          Cell: ({ row }) => {
            const date = row.original?.createdAt ?? null;
            if (date) {
              return (
                <div className="">
                  {date !== null
                    ? moment.utc(date).local().format("DD-MM-YYYY HH:mm")
                    : "-"}
                </div>
              );
            } else {
              return <div className="">-</div>;
            }
          },
        },
        {
          Header: "ID Proposal",
          accessor: "identifier",
          headerClassName: "text-start",
          Cell: ({ row }) => (
            <div className="text-start">{row.original.identifier}</div>
          ),
        },
        {
          Header: "Project",
          accessor: "projectName",
          headerClassName: "text-start",
          Cell: ({ row }) => <div className="">{row.original.projectName}</div>,
        },
        {
          Header: "Nilai Proposal",
          accessor: "amount",
          headerClassName: "text-start",
          Cell: ({ row }) => (
            <div className="">{`Rp. ${row.original.amount ? row.original.amount.toLocaleString("id-ID") : 0}`}</div>
          ),
        },
        {
          Header: "Status Proposal",
          accessor: "status",
          headerClassName: "text-start",
          Cell: ({ row }) => (
            <div className="">{ProposalStatus(row.original.status)}</div>
          ),
        },
        {
          Header: "Deskripsi",
          accessor: "descriptions",
          headerClassName: "text-start",
          Cell: ({ row }) => (
            <div className="">{row.original.descriptions || "-"}</div>
          ),
        },
        {
          Header: "Terpakai",
          accessor: "amountUsed",
          headerClassName: "text-start",
          Cell: ({ row }) => (
            <div className="">{`Rp. ${
              row.original.amountUsed
                ? row.original.amountUsed.toLocaleString("id-ID")
                : 0
            }`}</div>
          ),
        },
        {
          Header: "Saldo",
          accessor: "balance",
          headerClassName: "text-start",
          Cell: ({ row }) => (
            <div className="">{`Rp. ${row.original.balance ? row.original.balance.toLocaleString("id-ID") : 0}`}</div>
          ),
        },
        {
          Header: "Bukti",
          accessor: "action",
          Cell: ({ row }) => (
            <div className="flex items-center justify-center text-center">
              {row.original.status === "APPROVED" ||
              row.original.status === "PENDING_SETTLEMENT" ||
              row.original.status === "REFUND" ||
              row.original.status === "CLOSED" ? (
                // <Button
                //   label="Unggah"
                //   variant="gradient"
                //   size="sm"
                //   fullWidth
                //   onClick={() => {
                //     setUploadData({
                //       balance: row.original.balance,
                //       ewalletSubmission: row.original.id,
                //       typeModal: "add",
                //     });

                //     setActualizationData(row.original.cashActualizations);
                //     setShowModalUpload(true);
                //   }}
                // />
                <button
                  className="text-dark"
                  onClick={() => {
                    handleModalOption(row.original);
                  }}
                >
                  <EllipsisVerticalIcon className="size-6" />
                </button>
              ) : (
                <button
                  className="text-dark disabled:text-monochrome-100"
                  disabled
                  onClick={() => {
                    handleModalOption(row.original);
                  }}
                >
                  <EllipsisVerticalIcon className="size-6" />
                </button>
              )}
            </div>
          ),
        },
      ].filter(Boolean);

      return dynamicColumn;
    }, [selected]),
  };

  const handleChange = (name, event) => {
    setFilter((prevState) => ({
      ...prevState,
      [name]: event.value,
    }));
  };

  return (
    <>
      <ModalLoading showModal={isLoading} setShowModal={setIsLoading} />
      <ModalOption
        showModal={showModalOption}
        setShowModal={setShowModalOption}
        data={modalData}
        setData={setModalData}
        setUploadData={setUploadData}
        setShowModalUpload={setShowModalUpload}
        setActualizationData={setActualizationData}
        userData={userData}
      />
      <ModalConfirmation
        showConfirmation={showConfirmation}
        setShowConfirmation={setShowConfirmation}
        ConfirmFunction={async () => {
          // await PatchUser();
          AddSubmission();
        }}
        CloseFunction={() => setShowModalForm(true)}
        title="Konfirmasi Pengajuan"
        text="Apakah Anda ingin melanjutkan pengajuan proposal ini?"
      />
      <ModalDcmForm
        setData={setFormData}
        data={formData}
        showModal={showModalForm}
        setShowModal={setShowModalForm}
        showConfirmation={showConfirmation}
        setShowConfirmation={setShowConfirmation}
        dataCount={dataCount}
        balance={balanceData.depositBalance}
        type="add"
      />
      <ModalDcmUpload
        showModal={showModalUpload}
        setShowModal={setShowModalUpload}
        data={uploadData}
        setData={setUploadData}
        setUploadedImages={setUploadImages}
        actualizationData={actualizationData}
        uploadedImages={uploadedImages}
        AddData={AddHistory}
      />
      <Header
        title="Manajemen Kas Langsung"
        transparent
        rightButtonIcon={userData?.outlet?.retailer?.id ? <ExportIcon /> : null}
        rightButton={async () => {
          setLoadingDownload(true);
          const cleanedParams = _.pickBy(filter, (value) => value !== "");

          await ExportAuthTableExcelQueue(
            "DCM Report",
            "ewallet-submission",
            {
              ...cleanedParams,
              ...date,
              retailer: userData?.outlet?.retailer?.id,
            },
            1000,
            columns.transaction
              .map((column) => ({
                header: column.Header,
                key: column.accessor,
              }))
              .filter((data) => data.key !== "action")
              .filter((data) => !_.isEmpty(data.key)),
          );

          setLoadingDownload(false);
        }}
      />
      <img src={bg} alt="" className="absolute top-0 -z-50 -mt-5 w-full" />
      <div className="mx-auto max-w-screen-xl pb-24 pt-24">
        <div className="space-y-3">
          {/* MODAL IMAGE */}
          <ModalImage
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            image={image}
            setImage={setImage}
          />
          <div className="px-4">
            <Select
              className="col-span-full w-full sm:col-span-2"
              placeholder="Status Proposal"
              components={{ IndicatorSeparator: () => null }}
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "0.5rem 0.5rem 0 0",
                  borderColor: "#e6e6e6",
                  padding: "0.125rem 0.125rem",
                }),
              }}
              options={options.status}
              onChange={(e) => handleChange("status", e)}
              value={_.find(options.status, {
                value: filter.status,
              })}
            />
            <Datepicker
              align="right"
              setDate={setDate}
              date={date}
              size="w-full"
              className="rounded-b-md py-2.5"
            />
            <div className="mt-3">
              <Button
                label="Ajukan Proposal Baru"
                variant="primary"
                fullWidth
                size="sm"
                onClick={() => {
                  setShowModalForm(true);
                }}
              />
            </div>
          </div>
          <div className="space-y-5">
            <Table
              data={redeemTransactions.data ?? []}
              pages={generateArrayPages(redeemTransactions.pageCount ?? 0)}
              setPageSelected={setPageSelected}
              pageSelected={pageSelected ? pageSelected - 1 : 0}
              title={t("transaction.title")}
              columns={columns.transaction}
              isLoading={loadingRedeemTransactions}
              date={date}
              setDate={setDate}
            />
          </div>
        </div>
      </div>
    </>
  );
}

const ModalOption = ({
  showModal,
  setShowModal,
  data,
  setData,
  setUploadData,
  setShowModalUpload,
  setActualizationData,
  userData,
}) => {
  const navigate = useNavigate();
  const refundDataLocalStorage = JSON.parse(
    localStorage.getItem("refundData") || "{}",
  );

  return (
    <ModalBottom
      showModal={showModal}
      setShowModal={setShowModal}
      onClose={() => {
        setShowModal(false);
        setData({});
      }}
      defaultHeight={0.9}
      title=""
    >
      <div className="flex flex-col gap-2">
        {/* prevent user to upload document if this proposal is in refund process (cause it's affecting the balance) */}
        {refundDataLocalStorage?.proposalId === data.identifier && (
          <span className="text-xs text-red-500">
            * Transaksi ini sedang dalam proses refund. Mohon selesaikan
            pembayaran anda terlebih dahulu.
          </span>
        )}
        <Button
          label="Upload Bukti"
          fullWidth
          withIcon={<ArrowIcon className="text-dark" />}
          disabled={refundDataLocalStorage?.proposalId === data.identifier}
          onClick={() => {
            setUploadData({
              balance: data.balance,
              ewalletSubmission: data.id,
              typeModal: "add",
            });
            setActualizationData(data.cashActualizations);
            setShowModal(false);
            setShowModalUpload(true);
          }}
          justifyBetween
        />
        <Button
          label="Lihat Riwayat"
          fullWidth
          withIcon={<ArrowIcon className="text-dark" />}
          onClick={() => {
            setUploadData({
              balance: data.balance,
              ewalletSubmission: data.id,
              typeModal: "view",
            });
            setActualizationData(data.cashActualizations);
            setShowModal(false);
            setShowModalUpload(true);
          }}
          justifyBetween
        />
        <Button
          label="Pengembalian Dana"
          fullWidth
          disabled={
            data.balance < 10000 ||
            data.status === "REFUND" ||
            data.status === "CLOSED"
          }
          onClick={() => {
            const allowedBanks = ["BNI", "MANDIRI", "CIMB", "BANK MANDIRI"];

            const bankName =
              userData.bankAccount?.bankName?.toUpperCase() ||
              process.env.REACT_APP_VIRTUAL_ACCOUNT_FALLBACK ||
              "CIMB";

            const finalBank = allowedBanks.includes(bankName)
              ? bankName
              : process.env.REACT_APP_VIRTUAL_ACCOUNT_FALLBACK || "CIMB";

            navigate("/confirm-refund", {
              state: {
                ewalletSubmission: data.id,
                id: data.identifier,
                description: data.descriptions,
                retailer: userData?.outlet?.retailer?.id,
                nominal: data.balance,
                project: data.idProject,
                bank: finalBank,
              },
            });
          }}
          withIcon={<ArrowIcon className="text-dark" />}
          justifyBetween
        />
      </div>
    </ModalBottom>
  );
};

export default withAuth(CashManagement);
